import { apiSlice } from '../app/api/apiSlice';
import queryString from 'query-string';
import { updateBuyManager, updateBuyManagers } from '../store/slices/buyManager/buyManagers';

export const buyManagersApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllBuyManagers: builder.query({
      query: (params) => `buyManagers/all${params ? `?${queryString.stringify(params)}` : ''}`,
      providesTags: ['BuyManagers'],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(updateBuyManagers(data?.buyManagers));
        } catch (error) {
          if (error.status === 401) return; // Ignore 401 errors
          throw error;
        }
      },
    }),

    getBuyManagersById: builder.query({
      query: (params) => `buyManagers${params ? `?${queryString.stringify(params)}` : ''}`,
      providesTags: (result, error, id) => [{ type: 'BuyManagers', id }],
      keepUnusedDataFor: 12 * 60 * 60, // Cache for 12 hours
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(updateBuyManagers(data)); // Update the store with the fetched buy manager
        } catch (error) {
          if (error.status === 401) return; // Ignore 401 errors
          throw error;
        }
      },
    }),

    createBuyManager: builder.mutation({
      query: (buyManager) => ({
        url: 'buyManagers',
        method: 'POST',
        body: buyManager,
      }),
      invalidatesTags: ['BuyManagers'],
    }),

    updateBuyManager: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `buyManagers/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'BuyManagers', id }],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(updateBuyManager(data)); // Update the store with the updated buy manager
        } catch (error) {
          if (error.status === 401) return; // Ignore 401 errors
          throw error;
        }
      },
    }),

    deleteBuyManager: builder.mutation({
      query: (id) => ({
        url: `buyManagers/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['BuyManagers'],
    }),
  }),
});

export const {
  useGetAllBuyManagersQuery,
  useGetBuyManagersByIdQuery,
  useCreateBuyManagerMutation,
  useUpdateBuyManagerMutation,
  useDeleteBuyManagerMutation,
  useLazyGetAllBuyManagersQuery,
  useLazyGetBuyManagersByIdQuery,
} = buyManagersApi;
